import { ReactNode } from 'react';
import clsx from 'clsx';

interface GradientTextProps {
  children: ReactNode;
  className?: string;
  variant?: 'default' | 'accent' | 'monochrome';
}

const GradientText = ({
  children,
  className = '',
  variant = 'default',
}: GradientTextProps) => {
  const variantClass = {
    default: 'bg-gradient-to-r from-primary via-primary to-accent bg-clip-text text-transparent',
    accent: 'bg-gradient-to-r from-accent to-primary bg-clip-text text-transparent',
    monochrome: 'bg-gradient-to-r from-primary/100 to-primary/60 bg-clip-text text-transparent',
  };

  return (
    <span className={clsx(variantClass[variant], 'font-display font-bold', className)}>
      {children}
    </span>
  );
};

export default GradientText;
